import React from "react";
import { useStyles } from "./styles";

export const NewsWidgetColumn = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <div className={classes.column} ref={ref} role={props.role}>
      {children}
    </div>
  );
};
NewsWidgetColumn.muiName = "NewsWidgetColumn";
NewsWidgetColumn.displayName = "NewsWidgetColumn";
NewsWidgetColumn.defaultProps = {
  role: "column",
};
export default NewsWidgetColumn;

export * from "./NewsWidgetRow";
export * from "./NewsWidgetDate";
export * from "./NewsWidgetContent";
